import { render, staticRenderFns } from "./VTree.vue?vue&type=template&id=22a3d1f5&"
import script from "./VTree.vue?vue&type=script&lang=ts&"
export * from "./VTree.vue?vue&type=script&lang=ts&"
import style0 from "./VTree.vue?vue&type=style&index=0&id=22a3d1f5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports